import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';

import YouthForm from '../../../../components/Manage/YouthForm';

import IconPlus from 'cccisd-icons/plus-circle2';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;
let currentRole = Fortress.user && Fortress.user.acting.role.handle;

const AddYouthForm = props => {
    const modal = useRef();

    const onSubmit = async values => {
        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'youth',
            wrapId: values.wrapId,
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phoneNumber,
            language: values.language,
            dateOfBirth: values.dateOfBirth,
            youngAdult: values.youngAdult,
            parentPawns: JSON.stringify([...values.caregiver, ...values.careCoordinator]),
            careCoordinator: values.careCoordinator,
            group: values.site,
            receiveMessages: values.receiveMessages,
            youthStatus: values.youthStatus,
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ message: errorMessage, type: 'danger' });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <span>
                        <IconPlus spaceRight />
                        Add Youth
                    </span>
                </button>
            }
            title="Add New Youth"
        >
            <YouthForm
                initialValues={{
                    site: currentRole === 'careCoordinator' ? [Fortress.user.acting.group_id] : [],
                    careCoordinator: currentRole === 'careCoordinator' ? [Fortress.user.acting.id] : [],
                    caregiver: [],
                    receiveMessages: true,
                    youthStatus: 'Active',
                }}
                onSubmit={onSubmit}
            />
        </Modal>
    );
};

export default AddYouthForm;
